class ResultsController {
  constructor(
    MatchesFactory,
    $filter,
    $rootScope,
    $window,
    ngDialog,
    $stateParams,
    $location,
    $state,
    $document,
    $scope,
    animatedScroll
  ) {
    "ngInject";
    const vm = this;

    let $translate = $filter("translate");

    vm.rootScope = $rootScope;

    vm.$onInit = () => {
      if ($stateParams.id) {
        vm.matchId = $stateParams.id;
      }
      if ($window.localStorage.getItem(`resultsAutoScrolling${vm.matchId}`)) {
        vm.autoScrolling =
          $window.localStorage.getItem(`resultsAutoScrolling${vm.matchId}`) ===
          "true";
      } else {
        vm.autoScrolling = false;
      }
      vm.selectMatch = true;
      vm.validLeagues = [];
      if (vm.matchId) {
        vm.fetchResults();
      }
      if (vm.rootScope.isSAAF) {
        setTimeout(() => {
          if (!vm.autoScrolling) {
            vm.setAutoScrolling(true);
          }
        }, 5000);
      }
    };

    vm.setAutoScrolling = (value) => {
      vm.autoScrolling = value;
      $window.localStorage.setItem(`resultsAutoScrolling${vm.matchId}`, value);
      $window.location.reload();
    };

    vm.setSelectMatch = (value) => {
      vm.activeMatch = null;
      vm.selectMatch = value;
      vm.matchId = null;
      $location.path("/results");
    };

    vm.isRegistrationOpen = () => {
      let now = new Date();
      let start = new Date(vm.activeMatch.registration_start);
      let end = new Date(vm.activeMatch.registration_end);
      return now > start && now < end;
    };

    vm.getMatchPlayersOfLeague = (leagueId) => {
      return vm.activeMatch.matchPlayers
        .filter((m) => m.league_id === leagueId)
        .sort((a, b) => {
          if (a.total_score === b.total_score) {
            if (a["10s"] === b["10s"]) {
              if (vm.activeMatch.match_type === "outdoor") {
                if (a["Xs"] === b["Xs"]) {
                  return 0;
                }
                return a["Xs"] > b["Xs"] ? -1 : 1;
              } else {
                if (a["9s"] === b["9s"]) {
                  return 0;
                }
                return a["9s"] > b["9s"] ? -1 : 1;
              }
            }
            return a["10s"] > b["10s"] ? -1 : 1;
          }
          return a.total_score > b.total_score ? -1 : 1;
        });
    };

    vm.scrollNextLeague = (nextIndex) => {
      const duration = 2500;
      // const duration = 50;
      const offset = 40;
      // const offset = 10;
      if (vm.validLeagues[nextIndex]) {
        let lr = vm.validLeagues[nextIndex - 1];
        let pr = vm.getMatchPlayersOfLeague(lr.league_id).length;
        let ll = vm.validLeagues[nextIndex];
        let pp = vm.getMatchPlayersOfLeague(ll.league_id).length;
        animatedScroll
          .scroll(document.getElementById("league-results-" + ll.league_id), {
            duration: pr * duration,
            offset: pr * 1 * -1,
            easing: "easeInOutQuad",
          })
          .then((element) => {
            setTimeout(() => {
              vm.scrollNextLeague(nextIndex + 1);
            }, 1500);
          });
      } else {
        let lr = vm.validLeagues[nextIndex - 1];
        let pr = vm.getMatchPlayersOfLeague(lr.league_id).length;
        animatedScroll
          .scroll(document.getElementById("scroll-bottom-id"), {
            duration: pr * duration,
            offset: pr * offset * -1,
            easing: "easeInOutQuad",
          })
          .then((element) => {
            $window.location.reload();
          });
      }
    };

    vm.fetchResults = () => {
      $location.path("/results/" + vm.matchId);
      vm.selectMatch = false;
      let params = { include: "matchPlayers,matchLeagues" };
      MatchesFactory.results(vm.matchId, params).then(async (response) => {
        vm.activeMatch = response.data;
        vm.validLeagues = vm.activeMatch.matchLeagues.filter(
          (l) => l.entries > 0
        );
        if (vm.isRegistrationOpen()) {
          vm.activeMatch = null;
          ngDialog.open({
            template: "errorTemplate",
            data: {
              message: "Registration is still open",
            },
          });
        } else {
          let mpl = vm.activeMatch.matchPlayers.length;
          window.scrollTo(0, 0);
          if (vm.rootScope.isSAAF) {
            setTimeout(() => {
              animatedScroll
                .scroll(document.getElementById("scroll-bottom-id"), {
                  duration: mpl * 3000,
                  offset: 0,
                  easing: "easeInOutQuad",
                })
                .then((element) => {
                  $window.location.reload();
                });
            }, 3000);
          }
          // if (vm.autoScrolling === true && vm.validLeagues.length > 1) {
          //   angular.element(document).ready(function () {
          //     setTimeout(() => {
          //       vm.scrollNextLeague(1);
          //     }, 2000);
          //   });
          // } else if (vm.autoScrolling === true && vm.validLeagues.length > 0) {
          //   let lr = vm.validLeagues[0];
          //   let pr = vm.getMatchPlayersOfLeague(lr.league_id).length;
          //   animatedScroll
          //     .scroll(document.getElementById("scroll-bottom-id"), {
          //       duration: pr * 2300,
          //       offset: pr * 40 * -1,
          //       easing: "easeInOutQuad",
          //     })
          //     .then((element) => {
          //       $window.location.reload();
          //     });
          // }
        }
      });
    };
  }
}

export default ResultsController;



// WEBPACK FOOTER //
// ./client/app/components/results/results.controller.js